
import {PropType} from 'vue';
import {PageIdentity} from '../../src/Entity/Page';
import {Api} from '../../src/Api';
import { Fancybox } from "@fancyapps/ui";
import {Swiper, Pagination, Navigation, Mousewheel} from 'swiper';
import HeaderComponent from '../../components/Card/MainCard/Header/index.vue';
import ContentComponent from '../../components/Card/MainCard/Content/index.vue';
import PageLoader from './Component/page-loader.vue';
import "swiper/scss";
import "swiper/scss/pagination";

export default {
    components: { PageLoader, HeaderComponent, ContentComponent},
    props: {
        pageIdentity: {
            type: Object as PropType<PageIdentity>,
            required: true,
        },
        itemId: {
            type: String as PropType<string>,
            required: true,
        }
    },
    methods: {
        goBack() {
            if (!this.$router.go(-1)) {
                this.$router.push({
                    name: 'main-page',
                    params: this.pageIdentity,
                });
            }
        },
        async onApplyFilter(identity, tagValueId) {
            this.$router.push({
                name: 'page',
                params: {
                    categoryUrlName: this.pageIdentity.categoryUrlName,
                    pageUrlName: this.pageIdentity.pageUrlName
                },
                query: {
                    [identity]:tagValueId
                }
            });
        },
    },
    async mounted() {
        Fancybox.bind("[data-fancybox]", {});
        Fancybox.bind('[data-fancybox="gallery"]', {});
        const pageItem = await Api.getPageItem(this.pageIdentity, this.itemId);
        this.card = pageItem.card;

        document.querySelector('meta[property="og:title"]').setAttribute("content", pageItem.name);
        document.title = pageItem.name;

        this.$nextTick(() => {
            Swiper.use([Pagination]);
            Swiper.use([Navigation]);
            Swiper.use([Mousewheel]);
            const gallerySwiper = new Swiper('.js-swiper-gallery', {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    dynamicBullets: true,
                    clickable: true
                },
                loop: false,
                slidesPerView: 1
            });

        });
    },
    data() {
        return {
            card: null,
            fromRoute: null,
        };
    }

}
